// @ts-nocheck
import { date } from 'quasar';
import { defineStore } from 'pinia';
import { i18n } from 'src/boot/i18n';
import { notify } from 'src/components/notifications/notify';
import dateUtils from 'src/utils/date';
import { useSettingStore } from 'src/store/main';
import { convertLabel } from 'src/utils/ms_utlis';
import { masterDataApiService } from 'src/services';
import type { dynamicObj, CostingElement } from 'src/pages/assets';
import { getWithExpiry, setWithExpiry } from 'src/utils/cacheHelper';
import { masterDataLabelPrefix, masterDataPrefix } from 'src/constants';

export const useMasterDataLookupStore = defineStore('master_data_lookup', {
  state: () => ({
    aliases: {} as dynamicObj,
    data_types: [] as any,
    costingElementDictionary: {} as dynamicObj,
    data_types_loaded: false,
    loadingCostingElementPromise: null as Promise<void> | null,
    data: {} as Record<string, any>,
    sortby_data_types: {} as Record<string, any>,
    dynamicApiSampleValues: [] as any,
    loading: false,
    data_mode: '',
    xml_json: {},
    custom_records: [] as any,
    custom_templates: [] as any,
    costing_element_dictionary: 'costing_element_dictionary',
    readonly_types: [
      'purchase_order',
      'supplier',
      'purchase_order_header',
      'supplier_accounts',
      'receive_delivery',
      'receive_delivery_lines'
    ],
    exclue_fields: ['last_modified_on'],
    create_parameters: [],
    create_headers: [],
    create_body: [],
    preset_parameters: [],
    preset_headers: [],
    preset_body: [],
    column_paths: [],
    columns: [] as any,
    columnListPreferenc: [] as any,
    auth_options: [
      {
        label: 'None',
        value: 'none',
      },
      {
        label: 'ION API',
        value: 'ionapi',
      },
      {
        label: 'OAuth2',
        value: 'oauth2',
      },
    ],
    preset_information: {
      validated_response_textarea: '',
      auth_json: '',
      dynamic_api: false,
      json_path_edited: '',
      json_path: '',
      column_path: '',
      params: {},
      headers: {},
      body: {} as any,
      body_string: '',
      columns: [],
      auth_type: {
        label: 'None',
        value: 'none',
      },
      body_type: {
        label: 'application/json',
        value: 'application/json',
      },
      method: {
        label: 'GET',
        value: 'GET',
      },
    },
    endpoint_information: {
      validated_response_textarea: '',
      auth_json: '',
      dynamic_api: false,
      json_path_edited: '',
      json_path: '',
      column_path: '',
      params: {},
      headers: {},
      body: {} as any,
      body_strings: '',
      columns: [],
      auth_type: {
        label: 'None',
        value: 'none',
      },
      body_type: {
        label: 'application/json',
        value: 'application/json',
      },
      method: {
        label: 'GET',
        value: 'GET',
      },
    } as any,
    method_options: [
      {
        label: 'GET',
        value: 'GET',
      },
      {
        label: 'POST',
        value: 'POST',
      },
    ],
    body_type_options: [
      {
        label: 'application/json',
        value: 'application/json',
      },
      {
        label: 'multipart/form-data',
        value: 'multipart/form-data',
      },
    ],
    response_textarea: '',
    formatted_response_textarea: '',
    raw_json_response: {},
  }),
  getters: {},
  actions: {
    beautifyJson() {
      const unformatted_string = JSON.parse(
        this.endpoint_information.body_string,
      );
      const formatted_string = JSON.stringify(unformatted_string, null, 2);
      if (!formatted_string) {
        return;
      }
      this.endpoint_information.body_string = formatted_string;
    },
    resetAllFields() {
      this.endpoint_information = {
        validated_response_textarea: '',
        dynamic_api: false,
        json_path_edited: '',
        auth_json: '',
        json_path: '',
        column_path: '',
        params: {},
        headers: {},
        body: {},
        columns: [],
        auth_type: {
          label: 'None',
          value: 'none',
        },
        body_type: {
          label: 'application/json',
          value: 'application/json',
        },
        method: {
          label: 'GET',
          value: 'GET',
        },
      };
    },
    updateDynamicUrl() {
      try {
        const dynamicKeys: any = this.getDynamicKeysByUrl();
        if (dynamicKeys.length < this.dynamicApiSampleValues.length) {
          this.dynamicApiSampleValues = this.dynamicApiSampleValues.slice(
            0,
            dynamicKeys.length,
          );
        }
        dynamicKeys.forEach((element: any, index: number) => {
          if (index > this.dynamicApiSampleValues.length - 1) {
            this.dynamicApiSampleValues.push(element);
          }

          this.dynamicApiSampleValues[index].key = element.key;
        });
      } catch (e) {
        logError(e);
        return e;
      }
    },
    getDynamicKeysByUrl() {
      try {
        const url = this.endpoint_information.url_user_input;
        let tempString = '';
        let key: any = null;
        const params = url.split('?');
        const tempArray = params[1].split('&');
        const dynamicKeys = [];
        for (let i = 0; i < tempArray.length; i++) {
          tempString = tempArray[i];
          const pattern = /\[(.*?)\]/g;
          key = pattern.exec(tempString);
          if (!key) {
            continue;
          }
          const element = {
            key: key[1],
            value: '',
          };
          dynamicKeys.push(element);
        }
        return dynamicKeys;
      } catch (e) {
        logError(e);
        return e;
      }
    },
    generateDynamicUrl() {
      try {
        const url = this.endpoint_information.url_user_input;
        let tempString = '';
        let key: any = null;
        const params = url.split('?');
        const tempArray = params[1].split('&');
        for (let i = 0; i < tempArray.length; i++) {
          tempString = tempArray[i];
          const pattern = /\[(.*?)\]/g;
          key = pattern.exec(tempString);
          if (!key) {
            continue;
          }
          const element = this.dynamicApiSampleValues.find(
            (element: any) => element.key == key[1],
          );
          if (!element.value) {
             
            throw new Error(`Value for ${key[1]} not found`);
          }
          const value = element.value;
          tempArray[i] = tempArray[i].replace(key[0], value);
        }
        const formatted_params = tempArray.join('&');
        const formatted_url = params[0] + '?' + formatted_params;
        return formatted_url;
      } catch (e) {
        logError(e);
        return e;
      }
    },
    async deleteCustomRecord(record_id: string, index: number) {
      await masterDataApiService
        .deleteCustomRecord(record_id)
        .then((response: any) => {
          this.custom_records.splice(index, 1);
        });
    },
    async triggerCustomRecord(record_id: string) {
      this.loading = true;
      await masterDataApiService
        .triggerCustomRecord(record_id)
        .then((response: dynamicObj) => {
          return response;
        });
      this.loading = false;
    },
    async getMasterDataList(record_type: string) {
      const response =
        await masterDataApiService.getMasterDataList(record_type);
      if (!response) {
        throw response;
      }
      if (record_type == 'record') {
        this.custom_records = response.data;
      }
      if (record_type == 'template') {
        this.custom_templates = response.data;
      }
    },
    async createMasterData(record_type: string, mode: string) {
      this.loading = true;
      if (record_type == 'template') {
        this.preset_information.params = this.preset_parameters;
        this.preset_information.body = this.preset_body;
        this.preset_information.headers = this.preset_headers;
        this.preset_information.columns = this.column_paths;
        this.preset_information.json_path =
          this.preset_information.json_path.replace('data.', '');
        if (this.data_mode == 'json') {
          let json_path = '$';
          this.preset_information.json_path
            .split('.')
            .forEach((element: any) => {
              json_path += '[' + element + ']';
            });
          this.preset_information.json_path_edited = json_path;
        } else if (this.data_mode == 'xml') {
          this.preset_information.json_path_edited =
            this.preset_information.json_path;
        }

        const response = await masterDataApiService.createMasterData(
          this.preset_information,
          'template',
          mode,
        );
        if (!response) {
          throw response;
        }
      }
      if (record_type == 'record') {
        this.endpoint_information.params = this.create_parameters;
        if (
          this.endpoint_information.body_type.value == 'multipart/form-data'
        ) {
          this.endpoint_information.body = this.create_body;
        }
        this.endpoint_information.headers = this.create_headers;
        this.endpoint_information.columns = this.column_paths;
        this.endpoint_information.json_path =
          this.endpoint_information.json_path.replace('data.', '');
        if (this.data_mode == 'json') {
          let json_path = '$';
          this.endpoint_information.json_path
            .split('.')
            .forEach((element: any) => {
              json_path += '[' + element + ']';
            });
          this.endpoint_information.json_path_edited = json_path;
        } else if (this.data_mode == 'xml') {
          this.endpoint_information.json_path_edited =
            this.endpoint_information.json_path;
        }

        const response = await masterDataApiService.createMasterData(
          this.endpoint_information,
          'record',
          mode,
        );
        if (!response) {
          throw response;
        }
      }
    },
    async testDataExtraction(record_type: string) {
      this.loading = true;
      if (record_type == 'template') {
        this.preset_information.params = this.preset_parameters;
        this.preset_information.body = this.preset_body;
        this.preset_information.headers = this.preset_headers;
        this.preset_information.columns = this.column_paths;
        this.preset_information.json_path =
          this.preset_information.json_path.replace('data.', '');
        if (this.data_mode == 'json') {
          let json_path = '$';
          this.preset_information.json_path
            .split('.')
            .forEach((element: any) => {
              json_path += '[' + element + ']';
            });
          this.preset_information.json_path_edited = json_path;
        } else if (this.data_mode == 'xml') {
          this.preset_information.json_path_edited =
            this.preset_information.json_path;
        }

        const response = await masterDataApiService.testDataExtraction(
          this.preset_information,
        );
        if (!response) {
          this.loading = false;
          throw response;
        }
        this.loading = false;
        this.preset_information.validated_response_textarea = JSON.stringify(
          response.data,
          null,
          2,
        );
      }
      if (record_type == 'record') {
        this.endpoint_information.params = this.create_parameters;
        if (
          this.endpoint_information.body_type.value == 'multipart/form-data'
        ) {
          this.endpoint_information.body = this.create_body;
        }
        this.endpoint_information.headers = this.create_headers;
        this.endpoint_information.columns = this.column_paths;
        this.endpoint_information.json_path =
          this.endpoint_information.json_path.replace('data.', '');
        if (this.data_mode == 'json') {
          let json_path = '$';
          this.endpoint_information.json_path
            .split('.')
            .forEach((element: any) => {
              json_path += '[' + element + ']';
            });
          this.endpoint_information.json_path_edited = json_path;
        } else if (this.data_mode == 'xml') {
          this.endpoint_information.json_path_edited =
            this.endpoint_information.json_path;
        }

        const response = await masterDataApiService.testDataExtraction(
          this.endpoint_information,
        );
        this.loading = false;
        this.endpoint_information.validated_response_textarea = JSON.stringify(
          response.data,
          null,
          2,
        );
         
        return response;
      }
    },
    formatJsonPath(record_type: string) {
      const json_response: any = this.raw_json_response;
      let json_path;
      if (record_type == 'record') {
        if (this.endpoint_information.json_path == '') {
          return;
        }
        json_path = this.endpoint_information.json_path.replace('$.', '');
      } else if (record_type == 'template') {
        if (this.preset_information.json_path == '') {
          return;
        }
        json_path = this.preset_information.json_path.replace('$.', '');
      }
      json_path = 'data.' + json_path;
      const res = json_path.split('.').reduce(function (o: any, k: any) {
         
        return o && o[k];
      }, json_response);

      if (!res) {
        this.formatted_response_textarea = '';
        return;
      }

      this.formatted_response_textarea = JSON.stringify(res, null, 2);
    },
    async testEndpointResponse(record_type: string) {
      this.loading = true;
      let response: dynamicObj = {};
      if (record_type == 'template') {
        this.preset_information.params = this.preset_parameters;
        this.preset_information.body = this.preset_body;
        this.preset_information.headers = this.preset_headers;
        response = await masterDataApiService.testEndpointResponse(
          this.preset_information,
        );
        if (!response) {
          throw response;
        }
      } else if (record_type == 'record') {
        this.endpoint_information.params = this.create_parameters;
        if (
          this.endpoint_information.body_type.value == 'multipart/form-data'
        ) {
          this.endpoint_information.body = this.create_body;
        }
        this.endpoint_information.headers = this.create_headers;
        response = await masterDataApiService.testEndpointResponse(
          this.endpoint_information,
        );
        if (!response) {
          throw response;
        }
      }
      this.raw_json_response = response;
      this.response_textarea = JSON.stringify(response['data'], null, 2);
      this.data_mode = this.isJsonOrXml(this.response_textarea);
      if (this.data_mode == 'xml') {
        this.xml_json = await this.convertToXmlToJson(this.response_textarea);
      }
      this.formatted_response_textarea = this.response_textarea;
      this.formatJsonPath(record_type);
      this.loading = false;
    },
    async convertToXmlToJson(data: string) {

      const convert = await import('xml-js');
      let xmlData: string = data;
      xmlData = xmlData.replace(/\\\"/g, '"');
      xmlData = xmlData.replace(/<\?xml.*\?>/g, '');
      xmlData = xmlData.replace(/^"/, '');
      xmlData = xmlData.replace(/"$/, '');
      let jsonResult: string = convert.xml2json(xmlData, {
        compact: true,
        spaces: 2,
      });
      jsonResult = JSON.parse(jsonResult);
      return jsonResult;
    },
    isJsonOrXml(data: string) {
      const jsonRegex = /{((?:(\s+?)".+":.+((?:,|\s*)))+)}/gm;
      const xmlRegex = /<\/?([a-z][^>\s]*)\/?>?/gi;
      if (jsonRegex.test(data)) {
        return 'json';
      } else if (xmlRegex.test(data)) {
        return 'xml';
      } else {
        return 'unknown';
      }
    },
    async getDataSetAliases() {
      this.aliases = {};
      const response = await masterDataApiService.getDataSetTypesAliases();
      if (!response) {
        return;
      }
      const aliases: Record<string, string> = response.alias;
      for (const [key, value] of Object.entries(aliases)) {
        this.aliases[key] = value;
      }
    },

    async getAllCostingElementList() {
      this.costingElementDictionary = {};
      const data_type = 'costing_element';

      const request_params = {} as dynamicObj;
      request_params['skip'] = 0;
      request_params['limit'] = 900;
      request_params['data_type'] = data_type;
      request_params['sort_order_json'] = JSON.stringify([
        { field: 'charge_count', direction: 'desc' },
      ]);

      await this.getDataByType(request_params);

      let icon = '';
      if (!this.data[data_type]) {
        return;
      }

      for (const costingElement of this.data[data_type].data) {
        icon =
          !costingElement.charge_icon ||
          costingElement.charge_icon.toLowerCase() == 'default'
            ? 'charges.svg'
            : costingElement.charge_icon;
        this.costingElementDictionary[costingElement.costing_element] = {
          value: costingElement.costing_element,
          label: costingElement.description,
          icon: icon,
          distribution_method: costingElement.distribution_method,
        };
      }

      setWithExpiry(this.costing_element_dictionary, this.costingElementDictionary);
    },

    async prepareCostingElementDictionary() {
      // If already loaded, return immediately
      if(this.costingElementDictionary && Object.entries(this.costingElementDictionary).length > 0) {
        return;
      }

      // If currently loading, wait for it to complete
      if(this.loadingCostingElementPromise) {
        await this.loadingCostingElementPromise;
        return;
      }

      // Try to get from cache
      this.costingElementDictionary = getWithExpiry(this.costing_element_dictionary) as dynamicObj;

      if (
        this.costingElementDictionary &&
        Object.entries(this.costingElementDictionary).length > 0
      ) {
        return;
      }

      // Store the promise so other callers can await it
      this.loadingCostingElementPromise = this.getAllCostingElementList();
      try {
        await this.loadingCostingElementPromise;
      } finally {
        this.loadingCostingElementPromise = null;
      }

      if (
        !this.costingElementDictionary ||
        Object.entries(this.costingElementDictionary).length == 0
      ) {
        notify.error(
          i18n.t('COSTING_ELEMENTS_NOT_CONFIGURED'),
        );
      }
    },
    async getCostingElementList(distributionMethods: any) {
      const costingElementList: CostingElement[] = [];
      await this.prepareCostingElementDictionary();

      for (const [index, costingElement] of Object.entries(
        this.costingElementDictionary,
      )) {
        if (
          distributionMethods.length == 0 ||
          distributionMethods.includes(costingElement.distribution_method)
        ) {
          costingElementList.push({
            value: costingElement.value,
            label: costingElement.label + ' (' + costingElement.value + ')',
            charge_icon: costingElement.icon,
          });
        }
      }
      if((!costingElementList || costingElementList.length == 0) && !this.loadingCostingElementPromise) {
         notify.error( i18n.t('COSTING_ELEMENTS_NOT_CONFIGURED'));
      }
      return costingElementList;
    },
    getCostingElementIcon(row: any) {

      let icon = '/icons/box.svg';

      if(row.parent_id && this.costingElementDictionary.hasOwnProperty(row.costing_element)) {
        icon = '/images/charges/' + this.costingElementDictionary[row.costing_element].icon;
      }

      return icon;
    },

    async getDataTypeFields(data_type: string) {
      if (
        this.data[data_type] &&
        this.data[data_type]['fields'] &&
        this.data[data_type]['fields'].length > 0
      ) {
        return;
      }

      try {
        let response = await masterDataApiService.getTypeFields(data_type);
        if (!response) {
          throw response;
        }

        if (!Array.isArray(response) || response.length == 0) {
          response = [];
        }

        this.setFields(data_type, response);
      } catch (err) {
        this.setFields(data_type, []);
        return;
      }
    },

    setFields(data_type: string, result: string[]) {
      if (!this.data[data_type]) {
        this.data[data_type] = {} as dynamicObj;
      }

      this.data[data_type]['fields'] = [];
      const fields: string[] = [];
      let has_id_field = false;

      result.forEach((item: string) => {
        if (!item) return;
        item = item.toLowerCase();
        fields.push(item);

        if (item == 'id') {
          has_id_field = true;
        }
      });

      if (!has_id_field) {
        fields.push('id');
      }
      this.data[data_type]['fields'] = fields;
    },


    async getDataSetTypes(include_fixed_datasets = true) {
      this.data_types = [] as any;
      const response = await masterDataApiService.getTypes(include_fixed_datasets);
      if (!Array.isArray(response) || response.length == 0) {
        return;
      }
      this.data_types = response;
      this.data_types_loaded = true;
    },

    async getDataByType(data: dynamicObj, filter_data_json_str = '') {
      const data_type = data['data_type'];
      // if(this.data[data_type] && this.data[data_type]['data'] && this.data[data_type]['data'].length > 0) {
      //   return;
      // }

      const response = await masterDataApiService.getData_V2(
        data,
        filter_data_json_str,
      );
      if (!response) {
        throw response;
      }

      if (!this.data[data_type]) {
        this.data[data_type] = {} as dynamicObj;
      }

      const record_ids = [] as string[];
      const rows = response.data;

      Array.from(rows).forEach((row: any, index: any) => {
        if (row.hasOwnProperty('last_modified_on')) {
          row['last_modified_on'] = row['last_modified_on']
            ? dateUtils.methods.formatDateAccordingToPreference(
                row['last_modified_on'],
              )
            : '-';
        }

        if (row.hasOwnProperty('created_on')) {
          row['created_on'] = row['created_on']
            ? dateUtils.methods.formatDateAccordingToPreference(
                row['created_on'],
              )
            : '-';
        }

        record_ids.push(row['id']);
      });

      this.data[data_type]['ids'] = record_ids;
      this.data[data_type]['data'] = rows;
      this.data[data_type]['total_records'] = response.total_records;
      this.data[data_type]['readonly'] = this.readonly_types.includes(data_type);
    },

    async setAlias(data_type: string, alias: string) {
      if (alias.length == 0) {
        alias = data_type;
      }
      const response = await masterDataApiService.setDataSetTypesAlias(
        data_type,
        alias,
      );

      if (!response || response.success !== true) {
        throw response;
      }

      this.aliases[data_type] = alias;
    },

    async updateRow(
      data_type: string,
      row: Record<string, any>,
      create = false,
      selected_row_index: number,
    ): Promise<any> {
      const response = await masterDataApiService.updateRecord(data_type, row);
      if (!response || response.success !== true) {
         
        return response;
      }
      if (!this.data[data_type]) {
        this.data[data_type] = { data: [], ids: [] };
      }

      if (create) {
        this.data[data_type].data.push(row);
        this.data[data_type].ids.push(row.id);
      } else {
        this.data[data_type].data[selected_row_index] = row;
      }
       
      return response;
    },

    async deleteRow(
      data_type: string,
      row_id: string,
      index: number,
    ): Promise<any> {
      const response = await masterDataApiService.deleteRecord(
        data_type,
        row_id,
      );
      if (!response || response.success !== true) {
         
        return response;
      }
      this.data[data_type].data.splice(index, 1);

       
      return response;
    },

    async getColumnLabelPreference(master_lookup_type: string): Promise<any> {
      const key = masterDataLabelPrefix + master_lookup_type.toUpperCase();
      const settings_store = useSettingStore();
      const setting = await settings_store.getSetting(key);
      if (!setting) return [];
      try {
        return JSON.parse(setting);
      } catch {
        console.warn(`[MasterDataLookup] Invalid JSON for ${key}, returning empty array`);
        return [];
      }
    },

    async getColumnPreference(master_lookup_type: string) {
      const key = masterDataPrefix + master_lookup_type.toUpperCase();
      const settings_store = useSettingStore();
      const setting = await settings_store.getSetting(key) as dynamicObj;
      return String(!setting ? '[]' : setting);
    },

    sortColumns(columnListPreferenc: any, tableColumns: any): any {
      if (!columnListPreferenc || columnListPreferenc.length < 1) {
        return tableColumns;
      }

      const tempColumns = JSON.parse(JSON.stringify(tableColumns));
      const tempColumnsMap = new Map();
      tableColumns = [];

      for (const column of tempColumns) {
        tempColumnsMap.set(column.field, column);
      }
      // prepare columns in sort order
      for (const column of columnListPreferenc) {
        if (tempColumnsMap.has(column)) {
          tableColumns.push(tempColumnsMap.get(column));
          tempColumnsMap.delete(column);
        }
      }
      tempColumnsMap.forEach((value: any, key: string) => {
        tableColumns.push(value);
      });

      return tableColumns;
    },

    async prepareColumns(type_name: string, is_hidden: boolean) {
      try {
        this.columns = [];
        const customColumList = await this.getColumnLabelPreference(type_name);
        const columnsMap = customColumList.reduce(
          (acc: { [x: string]: any }, col: { field: string | number }) => {
            acc[col.field] = col;
            return acc;
          },
          {},
        );

        const isReadOnly = this.data[type_name].readonly;
        if (!isReadOnly) {
          this.columns.push({
            name: 'id',
            label: 'id',
            field: 'id',
            align: 'left',
          });
        }

        for (const [index, field_name] of Object.entries(
          this.data[type_name].fields,
        )) {
          if (field_name == '') {
            return;
          }
          const name = String(field_name);
          if (field_name == 'id') {
            continue;
          }

          let label = name;

          if (name == 'last_modified_on' || name == 'created_on') {
            label = i18n.t(name);
          } else if (name === 'custom_field_10') {
            label = i18n.t('bank_id');
          } else {
            // replace underscore with space and make first letter capital
            label = convertLabel(label);
          }

          const finalLabel =
            columnsMap[name] && columnsMap[name].label
              ? columnsMap[name].label
              : label;
          this.columns.push({
            name: name,
            label: finalLabel,
            field: name,
            align: 'left',
          });
        }

        await this.getColumnSortPreference(type_name);
        this.applyColumnSort();
        if (!isReadOnly) {
          this.columns.push({
            name: 'action',
            label: i18n.t('action'),
            field: 'action',
            align: 'right',
          });
        }
      } catch (err) {
        logError(err);
      }
    },

    checkEmptyColumns(type_name: string): any {
      const columnsWithData = new Set();

      this.data[type_name].data.forEach((row: any) => {
        this.columns.forEach((column: any) => {
          if (row[column.name]) {
            columnsWithData.add(column.name);
          }
        });
      });

      return this.columns.filter(
        (column: any) => !columnsWithData.has(column.name),
      );
    },
    async getColumnSortPreference(type_name: string) {
      this.columnListPreferenc = JSON.parse(await this.getColumnPreference(type_name));
    },

    applyColumnSort() {
      this.columns = this.sortColumns(this.columnListPreferenc, this.columns);
    },
  },
});
